import { render, staticRenderFns } from "./NgConfirm.vue?vue&type=template&id=bcee97a4"
import script from "./NgConfirm.vue?vue&type=script&lang=js"
export * from "./NgConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports